import {saveAs} from "file-saver";
import {URLCategory, urls, URLSType} from "@/lib/urls";


export const saveText = (text: string, extension: string) => {
    var blob = new Blob([text], {type: "text/plain;charset=utf-8"});
    saveAs(blob, `formatchamp.${extension}`);
}

export const copyToClipboard = async(text: string) => {
    await navigator.clipboard.writeText(text);
}

export const dedupeURLs = (urls: Array<URLSType>) => {
    let urlHash: {[key: string]: URLCategory} = {};

    urls.forEach((url) => {
        if(!urlHash[url.category.value]){
            urlHash[url.category.value] = url.category
        }
    })

    const urlArray: Array<URLCategory> =  Object.keys(urlHash).map((key: string )=> urlHash[key]);
    return urlArray.sort((a, b) => a.priority - b.priority);
}


export const isPathCorrectCategory = (path: string, category: string) => {
    return path === category;
}

export const getSubGroups = (path: string): Array<URLCategory> => {
    const group = urls.filter((d) =>{
        return path.indexOf(d.path) === 0;
    });

    // return empty set if no group found
    if(group.length === 0 || !group[0].subGroups){
        return [];
    }
    return group[0].subGroups;
}
